import React, { useEffect } from "react";
import { getGradeList } from "../../actions/Grade.action";
import EditTerminalForm from "../../components/EditTerminalForm/EditTerminalForm";
import Layout from "../../components/shared/Layout/Layout";
import { connect } from "react-redux";

const EditTerminalPage = ({ grades, getGradeList }) => {
  useEffect(() => {
    if (grades === null) {
      getGradeList();
    }
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Terminal Assessment`}>
        <EditTerminalForm />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  getGradeList,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTerminalPage);
